import React from "react"
import { Subtract } from "utility-types"
import Modal from "react-bootstrap/Modal"

import Button from "../Button"
import { Feedback } from "../Validator"

export interface InjectedProps {
  valid: Feedback
  disabled: boolean
  setValid: (value: Feedback) => void
  setDisabled: (value: boolean) => void
}

export interface WithModalProps {
  isOpen: boolean
  toggle: () => void
  headerText: string
  toggleText: string
  onCancel?: () => void
  size?: "sm" | "lg" | "xl"
}

interface WithModalState {
  valid: Feedback
  disabled: boolean
}

const withModal = <P extends InjectedProps>(
  Component: React.ComponentType<P>
) =>
  class WithModal extends React.Component<
    Subtract<P, InjectedProps> & WithModalProps,
    WithModalState
  > {
    constructor(props: P & WithModalProps) {
      super(props)
      this.state = {
        valid: { valid: true },
        disabled: false,
      }
    }

    public render() {
      const {
        isOpen,
        toggle,
        headerText,
        toggleText,
        onCancel,
        size,
        ...props
      } = this.props

      const cancelButton =
        onCancel || !this.state.valid.valid ? (
          <Button variant="link" onClick={onCancel || toggle}>
            Cancel
          </Button>
        ) : null

      return (
        <Modal
          show={isOpen}
          size={size}
          // centered={true}
          backdrop="static"
          keyboard={false}
          scrollable={true}
          dialogClassName="shadow-5"
        >
          <Modal.Header>
            <Modal.Title>{headerText}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Component
              {...((props as unknown) as P)}
              valid={this.state.valid}
              disabled={this.state.disabled}
              setValid={this.setValid}
              setDisabled={this.setDisabled}
            />
          </Modal.Body>
          <Modal.Footer>
            {cancelButton}
            <Button
              variant="primary"
              onClick={toggle}
              disabled={this.state.disabled || !this.state.valid.valid}
            >
              {toggleText}
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }

    private setValid = (value: Feedback) => {
      this.setState({
        valid: value,
      })
    }

    private setDisabled = (value: boolean) => {
      this.setState({
        disabled: value,
      })
    }
  }

export default withModal
